var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';
import { Link } from '../Link';
import { colorPalette } from '../../colorPalette';
export const Breadcrumb = (_a) => {
    var { steps, separator = 'arrow', dataQa, labelColor = colorPalette.gray700, fontSize } = _a, rest = __rest(_a, ["steps", "separator", "dataQa", "labelColor", "fontSize"]);
    const isStringArrayType = (arr) => typeof arr[0] === 'string';
    const renderItems = (steps, fontSize) => {
        if (isStringArrayType(steps)) {
            return steps.map((step, i) => (React.createElement(Typography, { key: i, fontSize: fontSize }, step.toString())));
        }
        return steps.map((step, i) => step.url ? (React.createElement(Link, { key: i, color: labelColor, url: step.url, label: step.name, marginBottom: "0", marginTop: "0" })) : (React.createElement(Typography, { key: i, fontSize: fontSize }, step.name)));
    };
    return (React.createElement(MuiBreadcrumbs, Object.assign({}, rest, { "data-qa": dataQa ? dataQa : 'breadcrumbs-core', separator: separator === 'arrow' ? (React.createElement(ChevronRightOutlined, { sx: {
                fontSize: fontSize || '14px',
            } })) : ('/') }), steps && renderItems(steps, fontSize)));
};
